/**
 * Web 应用入口
 * 多页 hash 路由（App.tsx 内自管），不引 router
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './style.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
